import { render, staticRenderFns } from "./SuggestionGuestJustifications.vue?vue&type=template&id=059be3dc&"
import script from "./SuggestionGuestJustifications.vue?vue&type=script&lang=js&"
export * from "./SuggestionGuestJustifications.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionGuestJustifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059be3dc')) {
      api.createRecord('059be3dc', component.options)
    } else {
      api.reload('059be3dc', component.options)
    }
    module.hot.accept("./SuggestionGuestJustifications.vue?vue&type=template&id=059be3dc&", function () {
      api.rerender('059be3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/SuggestionGuestJustifications.vue"
export default component.exports